import { usePlatformStats } from '@/hooks/usePlatformStats';

export default function TrustMarquee() {
  const { stats } = usePlatformStats();
  const brands = stats.brands;

  if (brands.length === 0) return null;

  // Liste dupliquée pour un défilement continu sans coupure
  const loop = [...brands, ...brands];

  return (
    <section className="relative py-10 md:py-14 bg-background-100/60 border-y border-background-200/60 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <p className="text-center text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-foreground-500 mb-7">
          Ils nous font confiance
        </p>
      </div>

      <div className="relative">
        <div className="flex w-max animate-marquee gap-4 md:gap-6">
          {loop.map((brand, i) => {
            const inner = (
              <>
                <div className="w-10 h-10 rounded-md bg-background-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                  {brand.logo ? (
                    <img
                      src={brand.logo}
                      alt={brand.name || 'Boutique Zifek'}
                      className="w-full h-full object-contain p-1"
                    />
                  ) : (
                    <span className="text-sm font-bold font-heading text-primary-500">
                      {(brand.name || 'Z').charAt(0)}
                    </span>
                  )}
                </div>
                <span className="text-sm font-medium text-foreground-800 truncate max-w-[140px]">
                  {brand.name || 'Boutique Zifek'}
                </span>
              </>
            );

            const baseClass =
              'flex items-center gap-3 px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 min-w-[180px]';

            return brand.url ? (
              <a
                key={i}
                href={brand.url}
                target="_blank"
                rel="noopener noreferrer"
                title={`Visiter ${brand.name || 'la boutique'}`}
                className={`${baseClass} no-underline hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer group`}
              >
                {inner}
                <i className="ri-arrow-right-up-line text-xs text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </a>
            ) : (
              <div key={i} className={baseClass}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}